<template>
  <div>
    <!-- 吸顶导航 -->
    <van-sticky>
      <van-nav-bar
        style="background-color: #3f78f6; margin-bottom: 0rem; border: 0"
        title=""
        left-text=""
        left-arrow
        @click-left="onClickLeft"
      >
        <template #title>
          <span style="color: white; font-size: 0.4rem">在校查询</span>
        </template>
        <template #left>
          <van-icon name="arrow-left" color="white" size="18" />
        </template>
      </van-nav-bar>
    </van-sticky>
    <!-- 中间内容展示 -->
    <section class="van-doc-demo-section">
      <van-cell-group v-for="(item, index) in list" :key="index">
        <div v-if="item.valid != 0">
          <van-cell
            style="font-size: 0.4rem"
            :title="item.title"
            is-link
            :value="item.val"
            :to="{
              path: 'MySchoolList',
              query: { type: item.type, title: item.title },
            }"
          />
        </div>
        <div v-else>
          <van-cell
            style="font-size: 0.4rem"
            :title="item.title"
            :value="item.val"
          />
        </div>
      </van-cell-group>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      loading: false,
      finished: false,
      list: [],
      student: "",
      page: "",
      xiaoqu: "",
    };
  },
  //创建页面开启操作
  created() {
    //上页面的地址参数获取
    this.student = this.$route.query.student;
    this.xiaoqu = this.$route.query.xiaoqu;
    this.page = this.$route.query.page;
//获取本地缓存键值
    var json = window.localStorage.getItem("User");
    var jsonObj = JSON.parse(json);
    console.log("身份:" + jsonObj[0]["shenfen"]);
    var code;
    if (jsonObj[0]["shenfen"] == "老师" || jsonObj[0]["shenfen"] == "学生") {
      code = jsonObj[0]["number"];
    } else if (jsonObj[0]["shenfen"] == "学生") {
      code = jsonObj[0]["number"];
    } else {
      code = jsonObj[0]["phone"];
    }
    //调用API参数格式化
    var params_json = {
      userid: code,
      action: "ZDList",
      param1: "total",
      param2: "",
      param3: "",
      param4: "",
      param5: "",
    };
//绑定数据操作附带参数
    this.$http.post("/web/list", params_json).then(function (res) {
      console.log(res.data["rows"]);
      this.list = res.data["rows"];
    });
  },
  methods: {
    //左上角按钮操作
    onClickLeft() {
      this.$router.push({
        path: "Index",
        query: {
          page: this.page,
        },
      });
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= this.list.length) {
          this.finished = true;
        }
      }, 1000);
    },
  },
};
</script>

<style>
</style>